module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJEAAAAhCAIAAABWcN4BAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gYRCwAFjILOHQAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAABtSURBVGje7dqxDYBACEBRNC7A/ksxwm3AChYaY28jyXvNXc0PHVt3B0NkZkTsBjHOcT1VZRZ/ttZ6/vZsHs00QzM00wzN0EwzNEMzzdAMzTRDMzRDM83QDM00QzM00wzN+Oq+/X6fFmPPAMY5AeXJCvLafoXgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buttons_icons/window_button.png
// module id = 9
// module chunks = 0